import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import GeoApiService from '@/services/GeoApiService';
import {useGetOneCountry} from '@/hooks/useGeoPlaces';

const SelectCountry = ({ value, onChange, filters, setCountryId, clearOnChange, ...props }) => {
  const handleChange = useCallback((val) => {
    clearOnChange && clearOnChange();
    setCountryId(val);
    onChange(val);
  }, [clearOnChange, onChange, setCountryId]);

  return (
    <SelectElementCmp
      queryKey={'geo-places-countries'}
      filters={filters}
      service={GeoApiService}
      includeValue={''}
      value={typeof value === 'object' ? value?.name : value}
      onChange={handleChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      {...props}
    />
  );
};

SelectCountry.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  setCountryId: PropTypes.func,
  filters: PropTypes.object,
  clearOnChange: PropTypes.func
};
SelectCountry.defaultProps = {
  entity: {},
};

export default memo(SelectCountry);

const CountryView = ({value}) => {

  const {data} = useGetOneCountry(value);

  return (
    <div>
      {data?.name || 'N/A'}
    </div>
  );
};

CountryView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a components,
 * it is a function to render the Code components in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * */
export const renderCountry = (text) => {
  return (
    <CountryView value={text}/>
  );
};
